import { sessionService } from "Apis";

export const getSessionById = async (id: number) => {
  const res = await sessionService.sessionServiceReadSession({
    sessionId: id,
  });
  return res;
};
